import {observable} from 'mobx';
import {construct, ModelProperties} from '../utils';

export class OfferAssetType {
    @observable id!: number;

    @observable name!: string;

    constructor(assetType?: ModelProperties<OfferAssetType>) {
        if (assetType) {
            construct(this, assetType);
        }
    }
}
